import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import CreateEpkWizard from "./CreateEpkWizard/CreateEpkWizard";

export default function NewEpkBtn() {
  const { t } = useTranslation();
  const [isWizardOpen, setIsWizardOpen] = useState(false);
  return (
    <>
      <button
        onClick={() => setIsWizardOpen(true)}
        className="tw-flex tw-items-center tw-gap-2 tw-rounded-xl tw-bg-[#712CB0] tw-px-5 tw-py-2.5 tw-text-sm tw-font-semibold tw-text-white tw-transition-all hover:tw-bg-[#8B3FD9] active:tw-scale-95 tw-border-0 tw-cursor-pointer"
      >
        <FontAwesomeIcon icon={faPlus} className="tw-text-xs" />
        {t("New EPK")}
      </button>
      <CreateEpkWizard isOpen={isWizardOpen} onClose={() => setIsWizardOpen(false)} />
    </>
  );
}
